import { initEtrackerConsentHandling, isEtrackerConfig } from 'utils/etracker'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'store/store'

function EtrackerInitializer(): null {
    const etrackerConfiguration = useSelector(
        (state: AppState) => state.generalState.customizeJsData?.etrackerConfiguration,
    )

    useEffect(() => {
        if (!isEtrackerConfig(etrackerConfiguration)) {
            return
        }

        initEtrackerConsentHandling(etrackerConfiguration)
    }, [etrackerConfiguration])

    return null
}

export default EtrackerInitializer
